/**
 * Ayuda — Administración → Comercial
 */

import { ADM_COM_PRICES_ITEM } from './adm-com-prices.js'
import { ADM_COM_PROMOTIONS_ITEM } from './adm-com-promotions.js'
import { ADM_COM_COSTS_ITEM } from './adm-com-costs.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ADM_COM_HELP = {
  screenId: 'adm-com',
  label: 'Comercial',
  navPath: 'Administración → Comercial',
  keywords: [
    'precio', 'precios', 'lista de precios', 'promoción', 'promociones', 'descuento',
    '2x1', 'bonificación', 'regalo', 'costo', 'costos', 'precio de compra',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Comercial concentra listas de precios, promociones y costos de compra. El menú de la izquierda tiene Precios, Descuentos y Promociones, y Costos.',
  sidebarItems: [ADM_COM_PRICES_ITEM, ADM_COM_PROMOTIONS_ITEM, ADM_COM_COSTS_ITEM],
}
